import { SharedFileRequest } from "@wingspanhq/wingspan-api-sdk";

import { selectorIsRequirementReadyToUploadFile } from "../../../../selectors/selectorIsRequirementReadyToUploadFile";
import { RequirementTableItemData } from "../../../../types";

export const getPayerSharedFileRequirementIsUploadAvailable = (
  requirement: RequirementTableItemData,
  sharedFileRequest: SharedFileRequest | undefined
): boolean => {
  return selectorIsRequirementReadyToUploadFile(requirement, sharedFileRequest);
};
